var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"20e5a6dd44fdde2ed2f6c875099274f999825858"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["photone@laserfocus"]={id:"20e5a6dd44fdde2ed2f6c875099274f999825858"};
      